export default {
  title: 'Meine Dokumente',
  description: 'Deine hochgeladenen Geschäftsdokumente. Du kannst sie jederzeit herunterladen oder ersetzen.',
  document_types: {
    owner_document: 'Ausweisdokument des Inhabers',
    business_document: 'Geschäftsdokument',
  },
  kinds: {
    vat_registration: 'Umsatzsteuer-Registrierung',
    trade_registration: 'Gewerbeanmeldung',
    trade_license: 'Gewerbeerlaubnis',
    commercial_register_extract: 'Handelsregisterauszug',
    financial_statements: 'Jahresabschluss',
    bank_statement: 'Kontoauszug',
    shareholder_list: 'Gesellschafterliste',
    other: 'Sonstiges',
    passport: 'Reisepass',
    driver_license: 'Führerschein',
    id_card: 'Personalausweis',
    residence_permit: 'Aufenthaltstitel',
  },
  sides: {
    front: 'Vorderseite',
    back: 'Rückseite',
  },
  fields: {
    slot: 'Kategorie',
    document: 'Dokument',
    kind: 'Art',
    side: 'Seite',
    uploaded_at: 'Hochgeladen',
    expires_at: 'Gültig bis',
    retained_until: 'Aufbewahrt bis',
    deleted_at: 'Gelöscht',
    storage_deleted_at: 'Endgültig gelöscht',
    actions: 'Aktionen',
  },
  values: {
    no_slot: 'Sonstige',
    no_file_name: '—',
    version: 'v{{version}}',
  },
  filters: {
    type_placeholder: 'Nach Dokumenttyp filtern',
    kind_placeholder: 'Nach Art filtern',
  },
  retention: {
    deletable: 'Löschbar',
    tooltip:
      'Das deutsche Recht (GoBD / §147 AO) verpflichtet uns, dieses Dokument bis zum {{date}} aufzubewahren. Es kann erst nach diesem Datum gelöscht werden.',
    tooltip_no_date:
      'Dieses Dokument unterliegt einer gesetzlichen Aufbewahrungsfrist und kann noch nicht gelöscht werden.',
  },
  buttons: {
    upload: 'Hochladen',
    upload_other: 'Anderes Dokument',
    retry_slots: 'Dokumente konnten nicht geladen werden – erneut versuchen',
    download: 'Herunterladen',
    download_front: 'Vorderseite herunterladen',
    download_back: 'Rückseite herunterladen',
    reupload: 'Erneut hochladen',
    delete: 'Löschen',
  },
  empty: 'Du hast noch keine Dokumente hochgeladen.',
  delete_modal: {
    title: 'Dokument löschen',
    description:
      'Wähle, wie dieses Dokument gelöscht werden soll. "Löschen" archiviert es und blendet es aus deiner Liste aus. "Endgültig löschen" entfernt die Dateien unwiderruflich und ist erst möglich, wenn die gesetzliche Aufbewahrungsfrist abgelaufen ist.',
    delete: 'Löschen',
    permanently_delete: 'Endgültig löschen',
    cancel: 'Abbrechen',
    retention_alert:
      'Diese Dokumente unterliegen den gesetzlichen Aufbewahrungsfristen nach deutschem Recht (GoBD / §147 AO). Beim endgültigen Löschen werden die Dateien unwiderruflich entfernt.',
  },
  reupload_modal: {
    title: 'Dokument erneut hochladen',
    description: 'Lade eine neue Version dieses Dokuments hoch. Die vorherige Version wird ersetzt.',
    type: {
      label: 'Dokumenttyp',
      placeholder: 'Dokumenttyp auswählen',
    },
    kind: {
      label: 'Dokumentart',
      placeholder: 'Dokumentart auswählen',
    },
    front: {
      label: 'Vorderseite des Dokuments',
    },
    back: {
      label: 'Rückseite des Dokuments (optional für einige Dokumente)',
    },
    expires_at: {
      label: 'Ablaufdatum des Dokuments',
      placeholder: 'Ablaufdatum auswählen',
    },
    buttons: {
      select_file: 'Dokument auswählen',
      submit: 'Hochladen',
      cancel: 'Abbrechen',
    },
  },
  toasts: {
    download_error: 'Das Dokument konnte nicht heruntergeladen werden.',
    delete_success: 'Dokument erfolgreich gelöscht.',
    delete_error: 'Das Dokument konnte nicht gelöscht werden.',
    reupload_success: 'Dokument erfolgreich hochgeladen.',
    reupload_error: 'Das Dokument konnte nicht hochgeladen werden.',
  },
};
